if (!customElements.get('contact-request-form')) {
  customElements.define('contact-request-form', class extends HTMLElement {
    connectedCallback() {
      this.topic = this.querySelector('[data-contact-topic]');
      this.titleField = this.querySelector('[data-contact-title]');
      this.wrapper = this.querySelector('[data-contact-title-wrapper]');
      this.update = () => {
        const other = this.topic.value === 'Other';
        this.wrapper.hidden = !other;
        this.titleField.disabled = !other;
        this.titleField.required = other;
      };
      this.topic.addEventListener('change', this.update);
      this.update();
      const success = this.querySelector('[data-contact-success]');
      if (success) {
        // Preserve Shopify's rendered success message while removing submission parameters.
        const destination = new URL(success.dataset.contactUrl || window.location.pathname, window.location.origin);
        window.history.replaceState(window.history.state, '', destination.pathname);
      }
    }
    disconnectedCallback() {
      this.topic.removeEventListener('change', this.update);
    }
  });
}
